// extracted by mini-css-extract-plugin
module.exports = {"bg":"_3Csj2","inlineContent":"mt5iU","pageWrapper":"_2ZDP-","shd":"_1CVBM","left":"_3VgIC","right":"xRhBD","innerBg":"_35XkE"};